export class ARReportsConstants {
    static arReportsPopupWindowWidth = 1000;
    static arReportsPopupWindowHeight = 800;
    static ZERO_BALANCES = 'zeroBalances';
    static DEBIT_BALANCES = 'debitBalances';
    static CREDIT_BALANCES = 'creditBalances';
    static DEBIT_CREDIT_BALANCES = 'debitCreditBalances';
    static ALL_BALANCES = 'allBalances';
}
